(() => {
  'use strict';
  const setup = card => {
    if (card.dataset.iucLoginBound) return;
    card.dataset.iucLoginBound = 'true';
    const portal = card.querySelector('.iuc-subscription-portal');
    const heading = card.querySelector('.iuc-login-heading');
    const label = card.querySelector('.iuc-login-email-label');
    const note = card.querySelector('.iuc-login-note');
    if (!portal || !heading || !label || !note) return;
    const nativeCopy = new Map();
    const keyboardControls = new WeakSet();
    const originalCopy = text => /^customer portal login$/i.test(text) || /^enter your email address in the field below and click/i.test(text) || /^your e[-\s]?mail address\s*:?$/i.test(text);
    const flatten = element => {
      for (let node = element.parentElement; node && node !== portal; node = node.parentElement) {
        if (node.matches('form,div,section,main,article,fieldset,center')) node.classList.add('iuc-login-native-shell');
      }
    };
    const findSendControl = () => {
      const candidates = [...portal.querySelectorAll('button,input[type="submit"],input[type="button"],a,[role="button"],div,span')].filter(node => {
        if (node.querySelector('input:not([type="hidden"]),textarea,select')) return false;
        const text = (node.value || node.textContent || '').trim().replace(/\s+/g, ' ');
        return /^send\s+(?:(?:a|sign-in|secure)\s+)?(?:link|email)$/i.test(text);
      });
      const leaf = candidates.find(node => !candidates.some(child => child !== node && node.contains(child)));
      if (!leaf) return null;
      const action = leaf.closest('button,input[type="submit"],input[type="button"],a,[role="button"],[onclick],[class*="button"],[class*="btn"]');
      return action && portal.contains(action) && !action.querySelector('input:not([type="hidden"]),textarea,select') ? action : leaf;
    };
    const enhance = () => {
      for (const [node, text] of nativeCopy) {
        if (!portal.contains(node) || node.textContent.trim() !== text) {
          node.classList.remove('iuc-login-original-copy');
          nativeCopy.delete(node);
        }
      }
      const email = portal.querySelector('input[type="email"],input[autocomplete="email"],input[name*="email" i],input[type="text"]');
      if (!email) {
        label.hidden = true;
        note.hidden = true;
        return;
      }
      const send = findSendControl();
      if (!send && !card.classList.contains('iuc-login-ready')) return;
      card.classList.add('iuc-login-ready');
      heading.hidden = false;
      label.hidden = false;
      note.hidden = false;
      if (!email.id) email.id = 'IUCSubscriptionEmail';
      label.htmlFor = email.id;
      email.classList.add('iuc-login-native-email');
      email.setAttribute('autocomplete', 'email');
      email.setAttribute('inputmode', 'email');
      email.setAttribute('placeholder', card.dataset.emailPlaceholder || '');
      flatten(email);
      portal.querySelectorAll('h1,h2,h3,p,div,span,label').forEach(node => {
        if (node.querySelector('input,button,a,[role="alert"],[role="status"],iframe,textarea,select')) return;
        const text = node.textContent.trim();
        if (originalCopy(text)) {
          node.classList.add('iuc-login-original-copy');
          nativeCopy.set(node, text);
        }
      });
      if (send) {
        send.classList.add('iuc-login-native-send');
        flatten(send);
        if (!send.matches('button,input,a,[role="button"]') && !keyboardControls.has(send)) {
          send.setAttribute('role', 'button');
          send.setAttribute('tabindex', '0');
          send.addEventListener('keydown', event => {
            if (event.key !== 'Enter' && event.key !== ' ') return;
            if (send.getAttribute('aria-disabled') === 'true' || send.matches('[disabled]')) return;
            event.preventDefault();
            send.click();
          });
          keyboardControls.add(send);
        }
      }
    };
    enhance();
    let queued = false;
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      queueMicrotask(() => { queued = false; enhance(); });
    }).observe(portal, { childList: true, subtree: true, characterData: true });
  };
  document.querySelectorAll('[data-iuc-login]').forEach(setup);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-iuc-login]').forEach(setup));
})();
